/* eslint-disable no-magic-numbers */
import { initWebSocketListeners } from "./agendaApiOrchestrator";

import state from "@/store/modules/meetingAgenda/state";
import getters from "@/store/modules/meetingAgenda/getters";
import reactions from "@/store/modules/meetingAgenda/reactions";
import mutations from "@/store/modules/meetingAgenda/mutations";
import actions from "@/store/modules/meetingAgenda/actions";

initWebSocketListeners();

export default {
	state,
	getters,
	mutations: {
		...mutations,
		...reactions,
	},
	actions,
	namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/meetingAgenda/index.js